import request from '@/utils/request';
/**获取列表数据 */
export function menuList(data) {
  return request.post('admin/menu/list', data);
}
/**菜单删除 */
export function menuDelete(data) {
  return request.post('admin/menu/delete', data);
}
/**菜单新增 */
export function addMenu(data) {
  return request.post('admin/menu/store', data);
}
/**菜单编辑 */
export function editMenu(data) {
  return request.post('admin/menu/edit', data);
}
/**菜单详情 */
export function menuDetail(data) {
  return request.post('admin/menu/detail', data);
}